import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import SportsNavBar from "../../components/common/SportsNavBar";
import Loading from "../../components/common/Loading";
import NewsSection from "../../components/home/NewsSection";
import { fetchNHLNews } from "../../services/api";

function NHL() {
  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadNews();
  }, []);

  const loadNews = async () => {
    const data = await fetchNHLNews();
    setArticles(data);
    setLoading(false);
  };

  if (loading) return <Loading />;

  return (
    <>
      <Helmet>
        <title>NHL News | Bharat Abroad Sports</title>
        <meta
          name="description"
          content="Latest NHL updates, team standings, match results, and stats."
        />
      </Helmet>

      <SportsNavBar />

      <div
        style={{ background: "#f5f5f5", minHeight: "100vh", padding: "20px" }}
      >
        <div style={{ maxWidth: "1400px", margin: "0 auto" }}>
          <NewsSection title="NHL News" articles={articles} category="nhl" />
        </div>
      </div>
    </>
  );
}

export default NHL;
